import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    Button,
} from '@quadminds/mindkit';
import { RiLoader4Line } from '@remixicon/react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useDeleteConversation } from '../../../../hooks/useDeleteConversation';
import { useChatContext } from '../../../../providers/Chat/Chat.provider';

interface DeleteAlertProps {
    id: string;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteAlert: React.FC<DeleteAlertProps> = ({ open, setOpen, id }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { conversationId, setReset } = useChatContext();
    const { mutate: deleteConversation, isPending } = useDeleteConversation();
    const handleDelete = () => {
        if (id) {
            deleteConversation(
                { conversationId: id },
                {
                    onSuccess: (response, variables) => {
                        setOpen(false); // close alert
                        queryClient.invalidateQueries({ queryKey: ['conversations'] }); // invalidate conversations query

                        if (conversationId && conversationId === variables.conversationId) {
                            setReset(true); // reset chat context
                        }
                    },
                },
            );
        }
    };
    return (
        <AlertDialog open={open}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('modals.deleteChat.title')}</AlertDialogTitle>
                    <AlertDialogDescription>{t('modals.deleteChat.description')}</AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={() => setOpen(false)}>{t('modals.common.cancel')}</AlertDialogCancel>
                    <Button variant="destructive" onClick={handleDelete} disabled={false}>
                        {isPending ? (
                            <RiLoader4Line className="animate-spin" />
                        ) : (
                            <span className="text-white">{t('modals.deleteChat.accept')}</span>
                        )}
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default DeleteAlert;
